const TableHead=({headings,onSelectAll})=>{
    return (
        <thead>
            <tr >
                <th className="col-header">   <input type="checkbox" onChange={onSelectAll} /></th>
                <th className="col-header">ID</th>
                {
                    headings.map((item,idx)=>{
                        return (
                            <th key={idx} className="col-header">{item}</th>
                        )
                    })
                }
               
                <th className="col-header">Status</th>
                <th className="col-header">UTR Number</th>
                
            </tr>
        </thead>
    )
}
export default TableHead;